import { useId, useState } from 'react';

/**
 * Поле за парола с бутон за показване.
 *
 * Без него грешките са невидими: при сгрешена клавиатурна подредба
 * набраното изглежда еднакво, а системата просто отказва.
 */
export default function PasswordInput({
  value,
  onChange,
  autoComplete = 'off',
  autoFocus = false,
  onEnter,
  placeholder,
  disabled,
  ...rest
}) {
  const [visible, setVisible] = useState(false);
  const id = useId();

  return (
    <div style={{ position: 'relative', display: 'flex' }}>
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter' && onEnter) onEnter(); }}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        placeholder={placeholder}
        disabled={disabled}
        style={{ width: '100%', paddingRight: 34 }}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        disabled={disabled}
        title={visible ? 'Скрий паролата' : 'Покажи паролата'}
        aria-label={visible ? 'Скрий паролата' : 'Покажи паролата'}
        style={{
          position: 'absolute',
          right: 1,
          top: 1,
          bottom: 1,
          width: 32,
          border: 'none',
          background: 'transparent',
          cursor: disabled ? 'not-allowed' : 'pointer',
          padding: 0,
          fontSize: 15,
          lineHeight: 1,
          color: 'var(--muted)',
        }}
      >
        {visible ? '🙈' : '👁'}
      </button>
    </div>
  );
}
